import { createRoutine } from 'redux-saga-routines';

export const drugListRoutine = createRoutine('DRUG/LIST');
export const drugLookupRoutine = createRoutine('DRUG/LOOKUP');
export const drugDetailsLookupRoutine = createRoutine('DRUG/LOOKUP_DETAILS');
export const drugFormLookupRoutine = createRoutine('DRUG/LOOKUP_FORM');
export const drugDiscountPriceRoutine = createRoutine('DRUG/DISCOUNT_PRICE');
export const drugDiscountPriceApiRoutine = createRoutine('DRUG/DISCOUNT_PRICE_API');
export const drugDescriptionRoutine = createRoutine('DRUG/DESCRIPTION');
